export const PenumbraSymbol = Symbol.for('penumbra');
